import { Injectable } from '@angular/core';
import { CookiesService } from './cookies.service';

@Injectable({
  providedIn: 'root'
})
export class TokenCookieService {
  private readonly tokenName = 'authToken_anz_external'; // Cookie name

  constructor(private cookiesService: CookiesService) {}

  saveToken(token: string): void {
    this.cookiesService.saveCookies(this.tokenName, token);
  }

  getToken(): string {
    return this.cookiesService.getCookie(this.tokenName);
  }

  deleteToken(): void {
    this.cookiesService.deleteCookies(this.tokenName);
  }

  hasToken(): boolean {
    return this.getToken() !== '';
  }
}
